import React from 'react';
import GuestHeader from './Guest';

const Header = () => {
  return <GuestHeader />;
};

export default Header;
